import { useState, useEffect } from 'react';
import { Device, OperatingSystem } from '@capacitor/device';

interface DeviceInfo {
  isMobile: boolean;
  isRunningInBrowser: boolean;
  userOperatingSystem: OperatingSystem;
}

const useDeviceInfo = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isRunningInBrowser: false,
    userOperatingSystem: 'unknown',
  });

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      const device = await Device.getInfo();
      const userAgent = navigator.userAgent;

      const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

      const isRunningInBrowser = device.platform === 'web';

      const userOperatingSystem = isMobile ? device.operatingSystem : 'unknown';

      setDeviceInfo({
        isMobile,
        isRunningInBrowser,
        userOperatingSystem,
      });
    };

    fetchDeviceInfo();
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
